import { Injectable } from '@angular/core';
import {
    AppointmentModel,
    ENDPOINTS,
    ODataAppointmentSlotsPayload,
    OnlineOnlyService,
    UriUtilitiesService,
} from '@evorait/pace-core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { OdataAppointmentSlotResponseModel, OdataSlotIntervalModel } from './appointment-booking-model';

@Injectable({
    providedIn: 'root',
})
export class AppointmentBookingService {
    public constructor(
        private readonly uriUtilities: UriUtilitiesService,
        private readonly onlineOnlyService: OnlineOnlyService,
    ) {}

    public getAppointment(payload: ODataAppointmentSlotsPayload): Observable<OdataSlotIntervalModel[]> {
        const query = ENDPOINTS.AppointmentSet.toString();
        return this.onlineOnlyService.post<OdataAppointmentSlotResponseModel>(query, payload).pipe(
            map((response: OdataAppointmentSlotResponseModel) => {
                if (response) {
                    return AppointmentModel.fromODataAppointmentSlots(response).slotIntervals;
                }
                throw new Error(`AppointmentBookingService: getAppointment: Could not get appointment slots!`);
            }),
        );
    }
}
